import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ROUTES } from 'src/app/core/constants/routes';
import { DialogService } from 'src/app/core/services/dialog.service';
import { ButtonsState } from 'src/app/state/buttons-state';
import * as ButtonSelectionActions from "src/app/state/actions/button-click.actions";
import { VOUCHER_MODULE_NAMES } from 'src/app/core/constants/enums';

@Component({
  selector: 'app-voucher-dialog',
  templateUrl: './voucher-dialog.component.html',
  styleUrl: './voucher-dialog.component.scss'
})
export class VoucherDialogComponent {
  constructor(protected dialogService: DialogService, private router: Router, private buttonsStore: Store<ButtonsState>) {
  }

  navigateToMyVouchersTab(): void {
    this.router.navigate([ROUTES.МАX_VOUCHERS]);
    this.buttonsStore.dispatch(ButtonSelectionActions.VOUCHERS_MODULE_SELECTED({ button: VOUCHER_MODULE_NAMES.MY_VOUCHERS }));
    this.dialogService.closeDialog();
  }
}
